
import { React, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import json from "../services/jsonData.json";
import { useNavigate } from "react-router-dom";
import TitleCard from "./TitleCard";

const Favorites = () => {
  let navigate = useNavigate();
  const [jsonData, setJsonData] = useState({ chapters: [] })
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    setJsonData(json)
    console.log(json)
  }, [])

  useEffect(() => {
    let favorited = localStorage.getItem('fav');
    if (favorited) {
      let parsefavorited = JSON.parse(favorited)
      setFavorites(parsefavorited)
    }
  });

  const getStringBetweenParenthese = (inputString) => {
    const regex = /\((.*?)\)/;
    const match = regex.exec(inputString);
    return match ? match[1] : null;
  }

  return (
    <div className="gallery">
      <Row>
        <i onClick={() => navigate("/starter")} class="bi bi-arrow-left-short back-button"></i>
        <TitleCard />
      </Row>

      <Row>
        {jsonData.chapters.map((chapter, i) => (
          favorites.includes(String(i)) &&
          <Col key={i} style={{ cursor: 'pointer', padding: '5px' }} xs="12" sm="12" md="12" lg="12" xl="12" xxl="12" onClick={() => navigate("/slog/" + i)}>
            <div class="card card-body" style={{ height: '100%', marginBottom: '0px' }}>
              <h5 style={{ textAlign: 'center' }}><i class="bi bi-book-half" style={{ color: '#a00395' }}></i> </h5>
              <h5 style={{ textAlign: 'center' }} class="card-title"> {(i + 1 + '.')}{getStringBetweenParenthese(chapter?.chapter_heading)}</h5>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Favorites;
